import { type ComponentProps, createContext, useContext } from "react";

import type { IconButton } from "@hightouch/htui";

type IconButtonSize = ComponentProps<typeof IconButton>["size"];

/**
 * The size of a chat's title-row icon buttons. A host whose own control ends
 * that row, like a sidebar's small collapse toggle, sets it so the row's
 * buttons match. Undefined keeps the buttons' default size.
 */
const ChatTitleButtonSizeContext = createContext<IconButtonSize>(undefined);
ChatTitleButtonSizeContext.displayName = "ChatTitleButtonSizeContext";

export const ChatTitleButtonSizeProvider = ChatTitleButtonSizeContext.Provider;

export const useChatTitleButtonSize = () =>
  useContext(ChatTitleButtonSizeContext);
